import React from 'react';
import BreadCrumbNav from './BreadCrumbNav';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import ScrollToTopButton from './ScrollToTopButton';
import SearchPopup from './SearchPopup';
import GalleryContent from './GalleryContent';
import PreLoader from './PreLoader';

const Gallery = () => {

  return (
    <div className="boxed_wrapper">
        {/* <PreLoader /> */}
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <BreadCrumbNav title="Gallery" />

        <GalleryContent />

        <Footer />
        <ScrollToTopButton />
    </div>
    );
  }
  
  export default Gallery;